var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.263 4.5H-0.000205994V7.5H25.263V12L37.8945 6L25.263 0V4.5Z","fill":"currentColor"}));
}

ArrowInline.defaultProps = {"width":"38","height":"12","viewBox":"0 0 38 12","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
